import React, { Fragment } from 'react';
import SuggestPageUpdateModal from './SuggestPageUpdateModal';

class SuggestUpdate extends React.Component {
    state = { showSuggestUpdateModal: false };

    render() {
        if (!(this.props.page && this.props.page.id)) {
            return null;
        }

        const { showSuggestUpdateModal } = this.state;
        return (
            <Fragment>
                <button className="suggest-an-edit__btn" onClick={() => this.setState({ showSuggestUpdateModal: true })} type="button">
                    <span role="img" aria-hidden="true">✏️</span>
                     Request an update
                </button>
                { showSuggestUpdateModal && <SuggestPageUpdateModal closeModal={() => this.setState({ showSuggestUpdateModal: false })} page={this.props.page} /> }
            </Fragment>
        );
    }
}

export default SuggestUpdate;
